import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { indianolaConfig } from "./data";

export default function IndianolaPage() {
  return <CityPageTemplate config={indianolaConfig} />;
}